import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const SignsItSupport3 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="signsItSupport" section="signs">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="signsItSupport:signs" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default SignsItSupport3;
